import { render, staticRenderFns } from "./NavbarUserOptions.vue?vue&type=template&id=47c12fcd&"
import script from "./NavbarUserOptions.vue?vue&type=script&lang=js&"
export * from "./NavbarUserOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports